import { Button } from "../../Atoms/Button/Button";

function RegularInfBox({
	yellowTitle,
	boldTitle,
	boldContent,
	content,
	buttonContent,
	buttonType,
	buttonRoute,
	white,
}) {
	return (
		<div>
			<p className="t5 c-yellow yellow-line right-side">{yellowTitle}</p>
			<h2 className={`t2 ${white && "c-white"}`}>{boldTitle}</h2>
			{boldContent && (
				<p className={`body-18 bold c-black ${white && "c-white"}`}>
					{boldContent}
				</p>
			)}
			{content && <p className={`body-18 ${white && "c-white"}`}>{content}</p>}
			{buttonContent && <Button type={buttonType} content={buttonContent} buttonRoute="/acerca" />}
		</div>
	);
}

export default RegularInfBox;
